import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1AdminOrganizationIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";

class AdminOrganizationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.AdminOrganization-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.AdminOrganization-001";

        let fk = {};

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_organizations",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminOrganizationIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminOrganization-001";
        payload.ShifamedMessage.AdminOrganization = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_organizations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminOrganization-001",
                "idoc-response": "v1.AdminOrganization-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminOrganizationIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let organization = {};

        organization["USID"] = this.getAttributeValue("USID");
        organization["Name"] = this.getAttributeValue("Name");
        organization["OrganizationType"] = this.getAttributeValue("OrganizationType");
        organization["ParentUSID"] = this.getAttributeValue("ParentUSID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminOrganization-001";
        payload.ShifamedMessage.AdminOrganization = organization;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/admin_organizations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminOrganization-001",
                "idoc-response": "v1.AdminOrganization-001",
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminOrganizationIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };
}

export default AdminOrganizationEnterpriseComponent;